<div [formGroup]="parentFormGroup" class="form-container">
  <mat-form-field appearance="outline">
    <mat-label i18n>Eligibility rules</mat-label>
    <mat-select id="eligibility-id" formControlName="id">
      @for (option of eligibilityRulesNames; track option) {
        <mat-option [value]="option.id">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
